import { combineReducers } from 'redux'
import { NAME, reducers } from './outage-analysis'
import analyticscore from './analytics/reducer'
import core from './core'
export default combineReducers({
  ...core.reducers,
  analyticscore,
  [NAME]: reducers[NAME],
})
